var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshake({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.25 18.858L18 30L6.74996 18.858C6.00792 18.1359 5.42343 17.268 5.03329 16.309C4.64314 15.3499 4.45581 14.3204 4.48307 13.2854C4.51033 12.2504 4.75161 11.2322 5.1917 10.295C5.63179 9.35783 6.26117 8.5219 7.04019 7.83989C7.81922 7.15788 8.73102 6.64455 9.71818 6.33224C10.7053 6.01993 11.7465 5.9154 12.776 6.02522C13.8056 6.13505 14.8012 6.45686 15.7003 6.97038C16.5993 7.4839 17.3823 8.17802 18 9.00902C18.6203 8.18405 19.4042 7.496 20.3026 6.98793C21.2011 6.47985 22.1947 6.1627 23.2214 6.0563C24.248 5.94991 25.2856 6.05657 26.2691 6.36961C27.2527 6.68265 28.161 7.19533 28.9373 7.87557C29.7136 8.5558 30.3411 9.38895 30.7806 10.3229C31.2201 11.2568 31.4621 12.2713 31.4914 13.3031C31.5208 14.3348 31.3369 15.3615 30.9512 16.3189C30.5655 17.2763 29.9863 18.1438 29.25 18.867",
    stroke: "#173058",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 9L13.0603 13.9395C12.7791 14.2208 12.6211 14.6023 12.6211 15C12.6211 15.3977 12.7791 15.7792 13.0603 16.0605L13.8748 16.875C14.9098 17.91 16.5898 17.91 17.6248 16.875L19.1248 15.375C20.0199 14.4799 21.2339 13.977 22.4998 13.977C23.7656 13.977 24.9797 14.4799 25.8748 15.375L29.2498 18.75",
    stroke: "#173058",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 23.2501L21.75 26.2501",
    stroke: "#173058",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 19.4999L25.5 22.4999",
    stroke: "#173058",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.ac54943cb5b79b458be8e624e7237273.svg";
export { ForwardRef as ReactComponent };